import React from "react";
import brittanyStark from "../../assets/screener/therapist-brittany-stark.png";
import bradyKilgoreMcDaniels from "../../assets/screener/therapist-brady-kilgore-mcdaniels.png";
import laNikaGraham from "../../assets/screener/therapist-lanika-graham.png";

type Therapist = {
  readonly name: string;
  readonly photo: string;
  readonly quote: string;
};

const THERAPISTS: readonly Therapist[] = [
  {
    name: "Brittany Stark, LPC",
    photo: brittanyStark,
    quote: "“I help children and parents navigate life's challenges by offering a safe, supportive space to talk and grow.”"
  },
  {
    name: "Brady Kilgore McDaniels, LMFT",
    photo: bradyKilgoreMcDaniels,
    quote:
      "“I have worked with families for over 20 years. It is my love, passion and honor to give my experience to help make families thrive.”"
  },
  {
    name: "LaNika Graham, LPC",
    photo: laNikaGraham,
    quote:
      "“I specialize in supporting adolescents and families, especially working with individuals from diverse backgrounds.”"
  }
];

export default function TherapistProfiles() {
  return (
    <div className="screener-card screener-therapists">
      <p className="screener-therapists__intro">
        Manatee has specialized family therapists across Texas, covered by insurance.
      </p>
      <ul className="screener-therapists__list">
        {THERAPISTS.map(therapist => (
          <li key={therapist.name} className="screener-therapist">
            <img className="screener-therapist__photo" src={therapist.photo} alt={therapist.name} />
            <div className="screener-therapist__body">
              <p className="screener-therapist__name">{therapist.name}</p>
              <p className="screener-therapist__quote">{therapist.quote}</p>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
